var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"popper-class":"my-autocomplete","fetch-suggestions":_vm.remoteMethod,"placeholder":"请输入内容"},on:{"select":_vm.targetChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"addr"},[_vm._v(_vm._s(item.company_name))])]}}]),model:{value:(_vm.targetValue),callback:function ($$v) {_vm.targetValue=$$v},expression:"targetValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394f8614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntelligentPerception.vue
// module id = null
// module chunks = 